var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTaskComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 35,
    viewBox: "0 0 34 35",
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#a9b1c1",
    height: 34,
    rx: 4.09014,
    width: 34,
    y: 0.726562
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.3998 17.3953v1.9336h-3.5977c-1.1015 0-2.0023.8955-2.0023 2.0001v2.0001h14.4v-2c0-1.1124-.8965-2.0002-2.0023-2.0002h-3.5977v-1.9338c1.4111-.6176 2.4-2.0268 2.4-3.6664 0-2.2047-1.7909-4.00018-4-4.00018-2.2047 0-4 1.79098-4 4.00018 0 1.637.9873 3.0483 2.4 3.6666zm7.9997 6.7336h-12.7999v1.6001h12.7999z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaskComplete);
export default __webpack_public_path__ + "static/media/icon-task-complete.c69ac9549395b3a332f2be0e0879ff7d.svg";
export { ForwardRef as ReactComponent };